import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Seo, breadcrumbJsonLd } from "../../components/Seo";
import { CallCta } from "../../components/CallCta";
import { Testimonials } from "../../components/Testimonials";
import { QC_CITIES } from "../../data/site-fr";

export default function VillesIndexFr() {
  return (
    <div data-testid="villes-index-fr-page">
      <Seo
        lang="fr-CA"
        title="Villes Desservies au Québec | 1st Nations Security"
        description="1st Nations Security dessert Montréal, Laval, Longueuil, Lévis, Gatineau, Québec, Trois-Rivières, Sherbrooke, Saguenay et Drummondville. Gardiens 24/7."
        path="/francais/villes/"
        jsonLd={[breadcrumbJsonLd([{ name: "Accueil", path: "/francais" }, { name: "Villes desservies", path: "/francais/villes" }])]}
      />
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="text-sm text-gray-500 mb-6" aria-label="Fil d'Ariane">
            <Link to="/francais" className="hover:text-[#FF9100]" data-testid="breadcrumb-fr-accueil">Accueil</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-300">Villes desservies</span>
          </nav>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6">
            Nos <span className="text-[#FF9100]">Zones de Service</span> au Québec
          </h1>
          <p className="text-lg text-gray-400 leading-relaxed max-w-3xl mb-6">
            1st Nations Security offre des services de gardiennage dans les grands centres du Québec — de la métropole montréalaise à la Capitale-Nationale, en passant par la Montérégie, l'Outaouais, la Mauricie, l'Estrie et le Saguenay–Lac-Saint-Jean.
          </p>
          <p className="text-gray-400 leading-relaxed max-w-3xl mb-12">
            Sélectionnez votre ville pour voir les détails du service local, ou appelez notre ligne de répartition 24/7 au +1 807-770-0243 pour organiser une couverture partout au Québec.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {QC_CITIES.map((c) => (
              <Link
                key={c.slug}
                to={`/francais/villes/${c.slug}`}
                data-testid={`ville-fr-card-${c.slug}`}
                className="group bg-[#14161C] hover:bg-[#1C1F28] border border-white/8 hover:border-[#FF9100]/40 rounded-2xl p-5 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center justify-between mb-2">
                  <h2 className="font-heading font-semibold text-white group-hover:text-[#FF9100] transition-colors flex items-center gap-2">
                    <MapPin className="w-4 h-4 text-[#FF9100]" /> {c.name}
                  </h2>
                  <ArrowRight className="w-4 h-4 text-[#FF9100] opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <p className="text-xs text-gray-500 mb-2">{c.region} · Pop. {c.pop}</p>
                <p className="text-sm text-gray-400 leading-relaxed">{c.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Testimonials fr />
      <CallCta heading="Votre ville n'est pas dans la liste?" sub="Appelez notre répartition 24/7 pour vérifier la couverture à votre adresse." testid="villes-fr-cta" />
    </div>
  );
}
